import React, {Component} from 'react';

import readyYetService from '../../../services/ready-yet';
import AnimatedWrapper from '../../core/animated-wrapper';
import SiteSubscription from '../../common/site-subscription';
import LoadingIndication from '../../common/loading-indicator';

import './is-angular-ready-yet.css';
import angularV5 from '../../../assets/images/angular-v5.png'
import shareService from '../../../services/share';

class IsAngularReadyYet extends Component {
  constructor(props) {
    super(props); 

    shareService.setupPage({
      title: "Is Angular Ready Yet?",
      tags: ["angular", "isangularreadyyet", "javascript"]
    });  

    this.state = { 
      currentRelease: null,
      isReady: null,
      isLoading: true,
      isError: false      
    };  
  }

  componentDidMount() {
    readyYetService.getAngularStatus()
      .then((angularStatus) => {

        const newState = Object.assign({
          isLoading: false,
          isError: false
        }, angularStatus);
          
        this.setState(newState);
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          isError: true
        });
      });      
  }

  render() {
    if (this.state.isLoading && !this.state.isError) {
      return (
        <div className='regular-page is-angular-ready-yet-page'>
          <div className='page-content-container'>
            <LoadingIndication />
          </div>
        </div>
      );
    }

    const shield = <img 
      src={angularV5} 
      className='shield'
      title='Angular v5' 
      alt='Angular v5' />;

    return (
      <div className='regular-page is-angular-ready-yet-page'>
        <div className='page-content-container'>
          <div className='question-and-shields'>
            {shield}
            <h3 className='question'>
              Is <span>Angular</span> v5 Ready Yet?
            </h3>
            {shield}
          </div>

          <h4 className='answer'>{ this.state.isReady ? "Yes!!!" : "No" }</h4>  
          <h5 className='details'>The latest version is: { this.state.release }</h5> 

          <SiteSubscription 
            text="Stop refreshing! Subscribe to our updates in order to get a notification when the answer will be YES." 
            source='Is-angular-ready-yet' />
        </div>
      </div>
    );
  }
};

const AnimatedCommunity = AnimatedWrapper(IsAngularReadyYet);
export default AnimatedCommunity;